import { UIEventHandler, useCallback, useRef } from 'react';

export function useCurrentScrollPosition<T>() {
    const currentScrollPosition = useRef(0);

    const setCurrentScrollPosition: UIEventHandler<T> = useCallback(
        (event) => {
            const scrollElement = event.target as HTMLElement;
            currentScrollPosition.current = scrollElement.scrollTop;
        },
        [currentScrollPosition]
    );

    return [currentScrollPosition.current, setCurrentScrollPosition] as const;
}
